import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthenticatedGuard } from './guards/authenticated.guard';

const routes: Routes = [
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'chat/:id',
    loadChildren: () => import('./pages/chat-detail/chat-detail.module').then(m => m.ChatDetailPageModule)
  },
  {
    path: 'wardrobe',
    loadChildren: () => import('./pages/my-wardrobe/my-wardrobe.module').then(m => m.MyWardrobePageModule)
  },
  {
    path: 'search-result',
    loadChildren: () => import('./pages/search-result/search-result.module').then(m => m.SearchResultPageModule)
  },
  {
    path: 'categories',
    loadChildren: () => import('./pages/category/categories/categories.module').then(m => m.CategoriesPageModule)
  },
  {
    path: 'create-product',
    loadChildren: () => import('./pages/product/create-product/create-product.module').then(m => m.CreateProductPageModule)
  },
  {
    path: 'subscriptions',
    loadChildren: () => import('./pages/subscriptions/subscriptions.module').then(m => m.SubscriptionsPageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'update-profile',
    loadChildren: () => import('./pages/update-profile/update-profile.module').then(m => m.UpdateProfilePageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then(m => m.TermsPageModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactPageModule)
  },
  {
    path: 'user/:id',
    canActivate: [AuthenticatedGuard],
    loadChildren: () => import('./pages/user-detail/user-detail.module').then(m => m.UserDetailPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule)
  },
  {
    path: 'new-password',
    loadChildren: () => import('./pages/auth/new-password/new-password.module').then(m => m.NewPasswordPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentPageModule)
  },
  {
    path: 'choose-language',
    loadChildren: () => import('./pages/choose-language/choose-language.module').then(m => m.ChooseLanguagePageModule)
  },
  {
    path: 'payment/success',
    loadChildren: () => import('./pages/payment-result/payment-result.module').then(m => m.PaymentResultPageModule)
  },
  {
    path: 'rate-user/:ratedUserId/:type/:productId',
    loadChildren: () => import('./pages/rating/rating.module').then(m => m.RatingPageModule)
  },
  {
    path: 'rating-list',
    loadChildren: () => import('./pages/rating-list/rating-list.module').then(m => m.RatingListPageModule)
  },
  {
    path: 'favorites',
    loadChildren: () => import('./pages/favorites/favorites.module').then(m => m.FavoritesPageModule)
  },
  // {
  //   path: 'payment/failed',
  //   loadChildren: () => import('./pages/payment-result/payment-result.module').then(m => m.PaymentResultPageModule)
  // },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
   {
    path: '',
    redirectTo: 'tabs',
    pathMatch: 'full'
  },
  { path: '**', component: NotFoundComponent },
 

  // {
  //   path: 'shipping-label',
  //   loadChildren: () => import('./pages/shipping-label/shipping-label.module').then( m => m.ShippingLabelPageModule)
  // },


  // {
  //   path: 'rate-user',
  //   loadChildren: () =>
  //     import('./pages/rating/rating.module').then(m => m.RatingPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
